module.exports = __webpack_public_path__ + "img/arrowDownW.4899eab4.svg";